const baseURL = '/supports';

async function save(data) {
    const res = await axios.post(`${baseURL}/`, data);
    return res.data;
}

export default {
    save,
};
